/**
 * Hand-built projection, not an entity serialization: it carries labels and no identifier (spec
 * `InvitationDetailsResponse`). `signInMethod` is a bare discriminant assembled by the server, not a
 * registered enum — the same treatment as `LoginResponse.status` — so it stays a plain `string` here
 * rather than the narrow union: a value this front does not yet know must still render as `password`
 * rather than crash. `expiresAt` is `null` when the invitation never expires (SSO-governed accounts).
 */
export type InvitationPayload = {
	readonly email: string;
	readonly firstName: string;
	readonly lastName: string;
	readonly organizationNames: readonly string[];
	readonly roleLabel: string | null;
	readonly facilityNames: readonly string[];
	readonly expiresAt: string | null;
	readonly signInMethod: string;
};

export type InvitationFetchedAction = {
	type: 'INVITATION_FETCHED';
	payload: InvitationPayload;
};

export default (payload: InvitationPayload): InvitationFetchedAction => ({
	type: 'INVITATION_FETCHED',
	payload,
});
